module.exports = __webpack_public_path__ + "img/1557614109876363265.60d1f675.png";